import { Reducer } from "redux";

import {
	VendorPartnerActions,
	VendorPartnerActionTypes
} from "../../../actions/Vendor/Partner";

export interface VendorPartnerState {
	readonly isLoading: boolean;
	readonly editPartnerDrawerVisible: boolean;
}

export const initialVendorPartnerState: VendorPartnerState = {
	isLoading: false,
	editPartnerDrawerVisible: false
};

export const VendorPartnerReducer: Reducer<
	VendorPartnerState,
	VendorPartnerActions
> = (
	state: VendorPartnerState = initialVendorPartnerState,
	action: VendorPartnerActions
): VendorPartnerState => {
	switch (action.type) {
		case VendorPartnerActionTypes.SHOW_VENDOR_PARTNER_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case VendorPartnerActionTypes.HIDE_VENDOR_PARTNER_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case VendorPartnerActionTypes.OPEN_EDIT_VENDOR_PARTNER_DRAWER:
			return {
				...state,
				editPartnerDrawerVisible: true
			};
		case VendorPartnerActionTypes.CLOSE_EDIT_VENDOR_PARTNER_DRAWER:
			return {
				...state,
				editPartnerDrawerVisible: false
			};
		default: {
			return state;
		}
	}
};

export default VendorPartnerReducer;
